import Masonry from 'masonry-layout'
import ImagesLoaded from 'imagesloaded'

export default {
  init() {
    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if ( vw > 768 && $('.post-type-archive-news .grid').length ) {
      ImagesLoaded(document.querySelector('.post-type-archive-news .grid'), function() {
        new Masonry('.post-type-archive-news .grid', {
          'itemSelector': '.grid-item',
          'columnWidth': 370,
          'gutter': 30,
        });
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/news.js